import { HttpClient, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { errorDetailBlob } from '@util/http';

import { endpoints } from '@environment';

import { LogErrorRequest } from '#types/log';

import { AuthService } from '@auth/services';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  payload$ = new BehaviorSubject<any>(null);
  display$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private authService: AuthService) {}

  async serverError(payload: LogErrorRequest, req?: HttpRequest<any>, res?: HttpErrorResponse) {
    let errorResponse: any = res?.error?.error ?? res?.error ?? res ?? {};

    if (errorResponse instanceof Blob) {
      errorResponse = await errorDetailBlob(res);
    }

    payload.timestamp = new Date();
    payload.title = payload.title ?? 'Error';
    payload.type = payload.type ?? 'server';
    payload.icon = payload.icon ?? 'fad fa-triangle-exclamation';

    payload.request = {};
    payload.request.url = res?.url ?? req?.urlWithParams ?? req?.url ?? window.location.href;
    payload.request.statusCode = res?.status;
    payload.request.method = req?.method;
    payload.request.body = JSON.stringify(req?.body);
    payload.request.requestId = errorResponse.requestId;
    payload.request.errorCode = errorResponse.errorCode ?? 'none';

    payload.client = {};
    payload.client.userAgent = navigator.userAgent;

    const localStorageJson = {};
    const sessionStorageJson = {};

    for (const key of Object.keys(localStorage)) {
      localStorageJson[key] = JSON.parse(localStorage[key]);
    }

    for (const key of Object.keys(sessionStorage)) {
      sessionStorageJson[key] = JSON.parse(sessionStorage[key]);
    }

    payload.client.localStorage = JSON.stringify(localStorageJson);
    payload.client.sessionStorage = JSON.stringify(sessionStorageJson);

    this.payload$.next(payload);
    this.display$.next(true);

    this.authService.nameid$.pipe(take(1)).subscribe((nameid) => {
      payload.client.nameid = nameid;

      this.http
        .post(endpoints.log.error, { ...payload })
        .pipe(take(1))
        .subscribe();
    });
  }

  dismissError() {
    this.payload$.next(null);
    this.display$.next(false);
  }
}
